module.exports = __webpack_public_path__ + "static/media/aeropage_small.1b5575a9.png";